import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { initialMarginSetupSlice } from './margin-setup.slice';
import { environment } from 'src/environments/environment';
import { MarginSetup } from '../../models/margin-setup.model';
import { computed } from '@angular/core';

export const MarginSetupStore = signalStore(
    { providedIn: 'root' },

    withState(initialMarginSetupSlice),

    withComputed((store) => ({
        snapshot: computed(() => ({
            marginId: store.marginId(),
            submittalId: store.submittalId(),
            marginStatusId: store.marginStatusId(),
            contractStartDate: store.contractStartDate(),
            contractEndDate: store.contractEndDate(),
            days: store.days(),
            hoursPerShift: store.hoursPerShift(),
            billRate: store.billRate(),
            payRate: store.payRate(),
            overtimeBillRate: store.overtimeBillRate(),
            overtimePayRate: store.overtimePayRate(),
            overtimeRateFactor: store.overtimeRateFactor(),
            holidayBillRate: store.holidayBillRate(),
            holidayPayRate: store.holidayPayRate(),
            holidayRateFactor: store.holidayRateFactor(),
            isAllInclusive: store.isAllInclusive()
        }))
    })),

    withComputed((store) => ({
        totalHours: computed(() => {
            const days = store.days() ?? 0;
            const hoursPerShift = store.hoursPerShift() ?? 0;
            return days * hoursPerShift;
        })
    })),

    withMethods((store) => ({
        updateMarginSetupFromData: (data: MarginSetup) => {
            patchState(store, { ...data });
        },
        updateMarginSetupField: (data: Partial<MarginSetup>) => {
            patchState(store, { ...data });
        },
        setMarginId(id: number) {
            patchState(store, { marginId: id });
        },
        getState: () => store,
        getSnapshot: () => store.snapshot()
    })),

    environment.storeWithDevTools('locums-margin-calculator-margin-setup-store')
);
